import React from 'react';
import type { PriceTable } from '../../types/content';

// Compact table card for accommodation and add-on prices.
export function PriceTableCard({
  table
}: {
  table: PriceTable;
}) {
  return <article className="flex flex-col rounded-[22px] bg-white p-6" data-id="element-724" data-mp="20liuzppu133r">
      <h3 className="type-card-title text-ink" data-id="element-725" data-mp="20mtydofd88uc">{table.title}</h3>
      <table className="mt-4 w-full text-left" data-id="element-726" data-mp="1vspooxeptmpk">
        <caption className="sr-only" data-id="element-727" data-mp="2aiwxelex7rd2">{table.title}</caption>
        <thead data-id="element-728" data-mp="2ahc2uvslw8f7">
          <tr className="type-small text-muted" data-id="element-729" data-mp="2al9llgb9uxyk">
            {table.columns.map((column, i) => <th key={column} scope="col" className={`pb-2 font-semibold ${i > 0 ? 'text-right' : ''}`} data-id="element-730" data-mp="25mga1tfjph11" data-mpi={i}>
                {column}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-731" data-mp="2fg5fyn3zdxeu">
          {table.rows.map(row => <tr key={row.label} data-id="element-732" data-mp="p6vhiydy4iik">
              <th scope="row" className="py-2 type-card-desc font-normal text-ink" data-id="element-733" data-mp="p63wuilw0572">
                {row.label}
              </th>
              {row.values.map((value, i) => <td key={`${row.label}-${i}`} className="py-2 text-right font-bold text-ink" data-id="element-734" data-mp="mzi5aizs7h3n" data-mpi={i}>
                  {value}
                </td>)}
            </tr>)}
        </tbody>
      </table>
      {table.note ? <p className="mt-auto pt-4 type-small text-body" data-id="element-735" data-mp="wua6dwskom36">{table.note}</p> : null}
    </article>;
}